"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("HubStyleTokens/theme");

var _TablePropTypes = require("./TablePropTypes");

var _UIClickable = _interopRequireDefault(require("../../button/UIClickable"));

var _Props = require("../../utils/Props");

var getBackgroundColor = function getBackgroundColor(hovered, sort) {
  if (hovered) return _theme.TABLE_SORTABLE_HOVER_BACKGROUND_COLOR;
  if (sort !== 'none') return _theme.TABLE_SORTABLE_SORTED_BACKGROUND_COLOR;
  return null;
};

var SortTH_TH = (0, _styledComponents.default)((0, _Props.omitProps)(_UIClickable.default, ['hovered', 'sort'])).attrs({
  tagName: 'th'
}).withConfig({
  displayName: "SortTH_TH",
  componentId: "sc-12m8u96-0"
})(["&&{background-color:", ";cursor:pointer;user-select:none;}"], function (_ref) {
  var hovered = _ref.hovered,
      sort = _ref.sort;
  return getBackgroundColor(hovered, sort);
});
SortTH_TH.propTypes = {
  hovered: _propTypes.default.bool,
  sort: _TablePropTypes.sortPropType
};
SortTH_TH.displayName = 'UISortTH_TH';
var _default = SortTH_TH;
exports.default = _default;
module.exports = exports.default;